import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3273abb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "attachment-view-wrapper"
}
const _hoisted_2 = ["data", "onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-lg icon-cloud-download" }, null, -1))
const _hoisted_4 = { class: "item-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.mail && _ctx.mail.hasAttachments)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachmentList, (attachment) => {
          return (_openBlock(), _createElementBlock("a", {
            data: attachment,
            key: attachment.id,
            onClick: ($event: any) => (_ctx.onAttachmentLinkClick(attachment)),
            class: _normalizeClass('attachment-link'),
            target: "_blank"
          }, [
            _hoisted_3,
            _createElementVNode("label", _hoisted_4, _toDisplayString(attachment.label), 1)
          ], 8, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}